import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { fetchManagerInformation } from '../../../store/slices/Citizenship/viewDocumentSlice';
import { Form } from '../../../components/common/Forms';
import { mangerInformationFields } from '../../../config/viewDocumentsFields';
import Notifications from '../../../components/common/Notifications';

const ManagerInformation = ({ empNuid }: { empNuid?: string | null }) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { managerInformation, managerInformationError } = useAppSelector(
    (state) => state.viewDocument
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchManagerInformation({ applicationId: id, empNuid }));
    }
  }, [id, empNuid, dispatch]);


  if (managerInformationError) {
    return (
    <Notifications messageInfo={managerInformationError} status={false}/>
    );
  }

  return (
    <div className='margin-top-4u !space-y-5'>
      <h3 className='h3 mb-6!'>Manager information</h3>
      <Form fields={mangerInformationFields} initialValues={managerInformation || {}} buttons={[]} />
    </div>
  );
};

export default ManagerInformation;
